<template>
    <div class="flex flex-col h-full justify-end">
        <!-- pb-56 md:pb-0 -->

        <div class="flex flex-1 flex-col justify-center">
            <div class="flex flex-col items-center md:mt-20 p-4">
                <img alt="Holubník logo" src="@/assets/img/holubnik.svg" class="w-32">
                <h1 class="text-4xl block">holubnik.sk</h1>
                <summary class="text-center list-none">Najrýchlejšie odosielanie súborov priamo medzi dvoma webovými
                    prehliadačmi.</summary>

                <div class="flex flex-row items-center my-4">

                    <span class="text-5xl lnr transition-all duration-500" :class="device1"></span>

                    <span class="text-3xl mx-2">&harr;</span>

                    <span class="text-5xl lnr transition-all duration-500" :class="device2"></span>

                </div>
            </div>

            <div class="flex flex-col justify-center items-center text-center mt-4">

                <router-link :to="{ name: 'tunel', params: { tunel: null } }"
                    class="bg-black hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none border border-black m-2">
                    <!-- Nové pripojenie -->
                    Vytvoriť tunel
                </router-link>


                <router-link :to="{ name: 'tech' }"
                    class="bg-white text-sm xhover:bg-gray-300 text-black xfont-bold py-2 px-4  rounded focus:outline-none  m-2">

                    Ako to funguje?
                </router-link>

            </div>
        </div>


        <div class="w-full text-center ">

            <div class="flex flex-col items-center mt-5 ">

                <router-link :to="{ name: 'contact' }" class="text-sm text-gray mb-1 text-gray-500">
                    Reklama
                </router-link>

                <a href="https://www.vasholubnik.sk/?utm_source=holubnik.sk&utm_medium=banner" target="_blank"
                    class="-m-4 mt-0">
                    <img alt="vasholubnik.sk" src="@/assets/img/vasholubnik.sk.png" class="max-w-full sm:max-w-lg">
                </a>
            </div>

        </div>

    </div>

</template>

<script>
// import Wormhole from '@/components/Wormhole.vue'

export default {

    name: 'Home',
    components: {
        // Wormhole,
    },

    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: 'holubnik.sk | Najrýchlejšie odosielanie súborov',
        // all titles will be injected into this template
        titleTemplate: null
    },

    data: function () {
        return {
            device1: 'lnr-laptop',
            device2: 'lnr-smartphone',
        }
    },

    beforeDestroy() {
        clearInterval(this.deviceChanger)
    },

    created() {
        this.deviceChanger()
    },

    mounted() {
        fetch('/util.wasm')
    },

    methods: {

        randomDevice() {
            const items = ['lnr-laptop', 'lnr-screen', 'lnr-smartphone', 'lnr-tablet']
            return items[Math.floor(Math.random() * items.length)];
        },

        deviceChanger() {
            this.deviceChager = setInterval(() => {
                this.device1 = this.randomDevice()
                this.device2 = this.randomDevice()
            }, 2000)

        },

    },
}
</script>

<style></style>
